goog.provide("shadow.js.shim.module$$mui$material$Link$default");
shadow.js.shim.module$$mui$material$Link$default = shadow.js.require(477, {})["default"];
